"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateTheme = exports.pickThemeProps = exports.extendCss = exports.omit = exports.merge = exports.createGridContext = void 0;

var _styledComponents = require("styled-components");

var _lodash = require("lodash");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createGridContext = function createGridContext() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var theme = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    breakpoints: props.breakpoints || ctx.breakpoints || theme.breakpoints,
    rootSize: props.rootSize || ctx.rootSize || theme.rootSize,
    columns: props.columns || ctx.columns || theme.grid.columns
  };
}; // ------------------------------------------
// merging utility
// ------------------------------------------


exports.createGridContext = createGridContext;

var merge = function merge() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var reservedKeys = arguments.length > 2 ? arguments[2] : undefined;
  if (!reservedKeys) return Object.assign({}, ctx, props);
  return _objectSpread({}, (0, _lodash.pick)(ctx, reservedKeys), {}, (0, _lodash.pick)(props, reservedKeys));
}; // ------------------------------------------
// omitting keys utility
// ------------------------------------------


exports.merge = merge;
var omit = _lodash.omit; // ------------------------------------------
// extendCss utility
// ------------------------------------------

exports.omit = omit;

var extendCss = function extendCss(value) {
  if (!value) return undefined;
  if (typeof value === 'function') return value(_styledComponents.css);
  return (0, _styledComponents.css)(_templateObject(), value);
}; // ------------------------------------------
// pickTheme props
// ------------------------------------------


exports.extendCss = extendCss;

var pickThemeProps = function pickThemeProps(props, keywords) {
  var result = {};
  keywords.forEach(function (item) {
    var value = props[item];
    if (value || typeof value === 'number') result[item] = value;
  });
  return result;
}; // ------------------------------------------
// calculate theme
// ------------------------------------------


exports.pickThemeProps = pickThemeProps;

var calculateTheme = function calculateTheme(_ref) {
  var breakpoints = _ref.breakpoints,
      keywords = _ref.keywords,
      props = _ref.props;
  var theme = {};
  keywords.forEach(function (item) {
    var propItem = props[item];
    if (propItem === undefined || propItem === null) return; // if it is a prop key as a breakpoint (like xs, sm,...)

    if (breakpoints.includes(item)) {
      if (_typeof(item) === 'object') {
        Object.keys(item).forEach(function (child) {
          (0, _lodash.set)(theme, [child, propItem], item[child]);
        });
      } else {
        (0, _lodash.set)(theme, ['size', item], propItem);
      }
    } else if (Array.isArray(propItem)) {
      propItem.forEach(function (value, i) {
        (0, _lodash.set)(theme, [item, breakpoints[i]], value);
      });
    } else if (_typeof(propItem) === 'object') {
      Object.keys(propItem).forEach(function (child) {
        (0, _lodash.set)(theme, [item, child], propItem[child]);
      });
    } else {
      breakpoints.forEach(function (breakpoint) {
        (0, _lodash.set)(theme, [item, breakpoint], propItem);
      });
    }
  });
  return theme;
};

exports.calculateTheme = calculateTheme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/coolgrid/dist/utils/utils.js
// module id = 36
// module chunks = 0